import { styled } from 'styled-system/jsx'

const ReceiptRoot = styled('div', {
  base: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
    paddingX: '24px',
    paddingY: '40px',
    backgroundColor: 'quickpass.surface',
    _print: {
      paddingY: '0',
      backgroundColor: '#FFFFFF',
      minHeight: 'auto',
    },
  },
})

const ReceiptActions = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    width: '100%',
    maxWidth: '560px',
    justifyContent: 'space-between',
    _print: {
      display: 'none',
    },
  },
})

const ReceiptCard = styled('div', {
  base: {
    width: '100%',
    maxWidth: '560px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    boxShadow: '0 24px 60px -20px rgba(128, 84, 255, 0.18)',
    padding: '32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    _print: {
      boxShadow: 'none',
      maxWidth: 'none',
      padding: '0',
    },
  },
})

const ReceiptHeader = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    borderBottom: '1px solid #EFEDF5',
    paddingBottom: '16px',
  },
})

const ReceiptBrand = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '14px',
    fontWeight: '700',
    color: 'quickpass.primary',
    letterSpacing: '0.3px',
  },
})

const ReceiptTitle = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '24px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const ReceiptAmountRow = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
})

const ReceiptAmountLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
  },
})

const ReceiptAmount = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '32px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const ReceiptRowGroup = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
  },
})

const ReceiptRow = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: '140px 1fr',
    gap: '12px',
    paddingY: '10px',
    borderTop: '1px solid #EFEDF5',
  },
})

const ReceiptLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
  },
})

const ReceiptValue = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.ink',
    wordBreak: 'break-word',
  },
})

const ReceiptFootnote = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: '#8A8398',
    lineHeight: '1.5',
  },
})

const NotFoundCard = styled('div', {
  base: {
    width: '100%',
    maxWidth: '560px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    boxShadow: '0 24px 60px -20px rgba(128, 84, 255, 0.18)',
    padding: '40px 32px',
    textAlign: 'center',
  },
})

const QuietText = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
  },
})

export {
  ReceiptRoot,
  ReceiptActions,
  ReceiptCard,
  ReceiptHeader,
  ReceiptBrand,
  ReceiptTitle,
  ReceiptAmountRow,
  ReceiptAmountLabel,
  ReceiptAmount,
  ReceiptRowGroup,
  ReceiptRow,
  ReceiptLabel,
  ReceiptValue,
  ReceiptFootnote,
  NotFoundCard,
  QuietText,
}
